// tuning/map.ts (M0-T06, §7.2)
import type { TuningBank } from '../schema/tuning';

export default {
  w: 112, h: 96, chunk: 16, genVersion: 1, tierRise: 1.0, seaBorder: 4, beachDepth: 6,
  plazaW: 10, plazaH: 8, shopW: 6, shopH: 5, museumW: 8, museumH: 6, sitesNearPlaza: 14, plotGap: 3,
  decorTrees: [150, 260], fruitTrees: [8, 12], rocks: [8, 14], ponds: [1, 3], rivers: [1, 2], maxRetries: 20,
} as const satisfies TuningBank;
